export const PRODUCT_BASICS_DETAILS_SERVER = `
  fragment ProductBasicDetails on Product {
    id
    name
    amountIn(currency: $currency)
    slug
    productCatalogSlug
    variantImages(storeNumber: $storeNumber, country: $country)
    servingInfo
    outOfStock
    sustainable
    ecoFriendly
    lockerProduct
    coreOnDemand
    storeProduct {
      embroidery
    }
  }
`;
